export * from './IFrameExtension';
